import baseService from "../base";

// perguntas do survey que serão atribuidas aos usuários
export async function fetchRespondentsSurvey(url) {
  const response = await baseService.get(url);
  return response?.data?.[0];
}

// perguntas do survey + info geral
export async function fetchSurveyData(url) {
  const response = await baseService.get(url);
  if (response?.data?.length === 0) {
    return { survey: { questions: [] } };
  }
  return response?.data?.[0];
}

export async function fetchData(url) {
  const response = await baseService.get(url);
  return response?.data;
}

export async function fetchArrayData(url) {
  const response = await baseService.get(url);
  const objectResponse = response?.data?.[0];
  return objectResponse;
}
